<template>
  <div>
        <stepheader :step="step"/>

        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
        <div class="col-12">
        
          <div
            class="selectgroup-pills"
            v-for="(device, index) in ticket.devices"
            v-bind:key="index"
          >
            <label class="selectgroup-item " style="display:block">
              <input
                type="radio"
                name="value"
                v-bind:value="device"
                v-model="ticket.device"
                class="selectgroup-input"
                checked=""
              />
              <span class="selectgroup-button text-start"> <strong>{{device.identificativoDevice}}</strong><br>
             modello {{device.brand.brand}} {{device.modello.modello}} 
             <span v-if="device.memoria">
memoria {{device.memoria.memoria}}

             </span></span>
            </label>
          </div>

          <!-- <button class="btn btn-lg btn-outline-primary btn-block text-center m-3" @click="setDanno(danno)" v-for="danno in danni">{{danno.descrizione}}</button> -->
        </div>

        
      </div>
     
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "infodevice",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
    console.log(`devices - length = ${this.ticket.devices.length}`);
    if(this.ticket.devices.length==0){
      var newStep = JSON.parse(JSON.stringify(this.step));
      newStep.id="error";
      newStep.title="Nessun dispositivo";
      newStep.message="Impossibile proseguire, non hai nessun dispositivo abilitato per l'apertura del ticket";
      newStep.buttons=[];
      this.$emit("changeView",newStep);
      localStorage.removeItem("srwizardtoken");
    }
  },
  methods: {
    fireaction: function (action, nextstep) {
      console.log(`devices.vue - action = ${action}`);
      switch (action) {
        default:
          if (!this.ticket.device) {

            swal({
              title: "Errore di compilazione",
              text: "Selezionare un dispositivo",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          }
          this.ticket.imei = this.ticket.device.identificativoDevice;
          this.ticket.idimeI_SKU = this.ticket.device.idimeI_SKU;
          this.ticket.cardAssociata = this.ticket.device.identificativoDevice;
          this.$emit("goto", nextstep)
          break;

      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>